// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-health-plan{.custom-accordion{padding-top:10px;padding-left:16px;padding-bottom:10px;padding-right:16px;margin-bottom:15px}div.card{border:1px solid #dee2e6}h3{margin-left:10px;font-size:16px;font-weight:600;margin-bottom:0}}", ""]);
// Exports
module.exports = exports;
